<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.SolarToolAswJsonEditedItem.description"
                        label="Description"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireResults",
		data: function () {
			return {
            }
        }
    }
</script>
